import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { APP_TITLE } from 'src/app/config/constant';
import { CoreService } from 'src/app/shared/services/core.service';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  public currentFullTitle: string;
  public currentTitle: string;

  constructor(
    private title: Title,
    private coreService: CoreService,
  ) {}

  public setTitle(title?: string) {
    const role = this.coreService.getCurrentAccountType();
    let newTitle = APP_TITLE;
    if (role) {
      newTitle += ` - ${role}`;
    }
    if (title) {
      newTitle += ` - ${title}`;
    }
    this.currentTitle = title;
    this.currentFullTitle = newTitle;
    this.title.setTitle(newTitle);
  }

  public clearTitle() {
    this.setTitle();
  }

  public updateTitle() {
    this.setTitle(this.currentTitle);
  }
}
